import { FirebaseOptions, initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';

// Your web app's Firebase configuration
export const firebaseConfig = JSON.parse(import.meta.env.VITE_FIREBASE_CONFIG) as FirebaseOptions;
const useEmulators = import.meta.env.VITE_USE_EMULATORS == 'true';

const app = initializeApp(firebaseConfig);
// The unsubscribe query is a bearer capability. Do not initialize Analytics
// while it is still present in the initial request URL.
const isUnsubscribeCapabilityPath = window.location.pathname === '/unsubscribe';
export const analytics = isUnsubscribeCapabilityPath ? undefined : getAnalytics(app);
export const firestore = getFirestore(app);
export const functions = getFunctions(app, 'europe-west3');

if (useEmulators) {
  connectFunctionsEmulator(functions, '127.0.0.1', 5001);
  connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
}
